





import { Vue, Component, Prop } from 'vue-property-decorator';
import { inject } from 'inversify-props';
import ProcessService from '@/services/crm/process.service';
import SessionService from '@/services/session.service';
import { InjectionIdEnum } from '@/enums/injection-id.enum';
import { ClientTypeEnum } from '@/enums/client-type.enum';

@Component({})
export default class CrmNewKanbanViewer extends Vue {
  @inject(InjectionIdEnum.CrmProcessService)
  private processService!: ProcessService;

  @inject(InjectionIdEnum.SessionService)
  private sessionService!: SessionService;

  @Prop({ required: true })
  readonly flowId!: number;

  @Prop({ required: true })
  readonly clientId!: string;

  @Prop({ required: true })
  readonly clientType!: ClientTypeEnum;

  @Prop()
  readonly defaultQueue!: number;

  @Prop()
  readonly processId!: number;

  @Prop({ default: false })
  readonly fromPainelRelacionamento!: boolean;

  private kanbanUrlValue = '';

  async mounted(): Promise<void> {
    let loader;
    try {
      loader = this.$loading.show({
        container: this.$refs.kanbanViewerContainer,
        canCancel: false,
      });

      await this.generateKanbanUrl();
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
    } finally {
      loader.hide();
    }
  }

  async generateKanbanUrl(): Promise<void> {
    if (this.isBuiltInMode) {
      this.kanbanUrlValue = await this.generateBuiltInKanbanUrl();
    } else {
      this.kanbanUrlValue = this.processService.getNewKanbanUrl(
        this.flowId,
        this.clientId,
        this.clientType,
        this.defaultQueue,
        this.processId,
        true,
        undefined,
        this.fromPainelRelacionamento,
      );
    }
  }

  get isBuiltInMode(): boolean {
    return this.sessionService && this.sessionService.builtInMode;
  }

  async generateBuiltInKanbanUrl(): Promise<string> {
    if (!this.clientId || !this.clientType) {
      return '#';
    }

    try {
      if (this.sessionService?.apiUrl360) {
        return this.processService.getNewKanbanUrl(
          this.flowId,
          this.clientId,
          this.clientType,
          this.defaultQueue,
          this.processId,
          true,
          undefined,
          this.fromPainelRelacionamento,
        );
      }

      let kanbanUrl = '';

      try {
        const geo360Url = this.sessionService.apiUrl360;
        if (geo360Url) {
          kanbanUrl = `${geo360Url}/crm/processo`;
        } else {
          const currentOrigin = window.location.origin;
          kanbanUrl = `${currentOrigin}/crm/processo`;
        }
      } catch (e) {
        const currentOrigin = window.location.origin;
        kanbanUrl = `${currentOrigin}/crm/processo`;
      }

      kanbanUrl += `/${this.processId ? this.processId : '0'}`;
      kanbanUrl += `?idFluxo=${this.flowId}`;
      kanbanUrl += `&tipoCliente=${ClientTypeEnum.Client.toString() === this.clientType
        ? 'CLIENTE' : this.clientType.toUpperCase()}`;
      kanbanUrl += `&idCliente=${this.clientId}`;
      kanbanUrl += `&filaPadrao=${this.defaultQueue}`;

      if (this.fromPainelRelacionamento) {
        kanbanUrl += '&fromPainelRelacionamento=true';
      }

      if (this.processService) {
        try {
          const token = this.processService.getApiToken();
          if (token) {
            kanbanUrl += `&token=${token}`;
          }

          const apiPath = this.processService.getApiPath();
          if (apiPath) {
            kanbanUrl += `&u=${apiPath}`;
          }
        } catch (e) {
          // Silent fail
        }
      }

      return kanbanUrl;
    } catch (error) {
      return '#';
    }
  }

  get kanbanUrl(): string {
    return this.kanbanUrlValue;
  }
}
